import styled from "styled-components";

export const contentStyle = {
    background: "#fff",
    top: "50%",
    left: "50%",
    right: "",
    bottom: "",
    transform: "translate(-50%,-50%)",
    position: "absolute",
    padding: "0",
    border: "",
    overflow: "",
    borderRadius: "",
    zIndex: "10",
    minHeight: "171px",
    outline: "none",
    WebkitTapHighlightColor: "transparent",
};

export const overlayStyle = {
    background: "rgba(0,0,0,0.6)",
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    zIndex: "9",
    WebkitTapHighlightColor: "transparent",
};

export const LossAversionPopup = styled.div`
    padding: 16px;
    text-align: center;
    display: inline-block;
    p {
        font-size: 0.9375rem;
        line-height: 24px;
        margin-bottom: 5px;
    }
`;
export const LossAversionButtonArea = styled.div`
    margin-top: 24px;
    button {
        margin-left: 16px;
    }
    button:first-child {
        border: 1px solid #1048c3;
    }
`;
